
import {define} from "observable:runtime";
import asset1 from "../style.css?url";

const assets = new Map([
  ["../style.css", asset1]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const {createUI, installHashImportBanner, installThemeToggle} = await import("../lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  return module;
});
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, canvasOutput, canvasTest, canvasTestReport } = createUI({ html });
return {createUI,installHashImportBanner,installThemeToggle,codeEditor,canvasOutput,canvasTest,canvasTestReport};
},
    inputs: ["html","display"],
    outputs: ["createUI","installHashImportBanner","installThemeToggle","codeEditor","canvasOutput","canvasTest","canvasTestReport"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-5`),
    expanded: [],
    variables: []
  },
  {
    id: 5,
    body: (view,codeEditor) => {
const code_gallery = view(codeEditor("canvas:img-gallery", {
  value: `const namen = ["smiley", "herz", "stern", "baum", "haus"]

ctx.font = "14px Arial"
ctx.textAlign = "center"
ctx.fillStyle = "black"

let x = 20
for (const name of namen) {
  drawPicture(ctx, name, x, 15, 70, 70)
  ctx.fillText(name, x + 35, 105)
  x = x + 90
}`
}));
return {code_gallery};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_gallery"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-6`),
    expanded: [],
    variables: []
  },
  {
    id: 6,
    body: (display,canvasOutput,code_gallery) => {
display(canvasOutput(code_gallery, { width: 470, height: 120 }));
},
    inputs: ["display","canvasOutput","code_gallery"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-8`),
    expanded: [],
    variables: []
  },
  {
    id: 8,
    body: (view,codeEditor) => {
const code_pos = view(codeEditor("canvas:img-pos", {
  value: `const x = 80
const y = 40

drawPicture(ctx, "smiley", x, y)

// rote Markierung auf der oberen linken Ecke (x, y)
ctx.fillStyle = "red"
ctx.beginPath()
ctx.arc(x, y, 5, 0, 2 * Math.PI)
ctx.fill()`
}));
return {code_pos};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_pos"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-9`),
    expanded: [],
    variables: []
  },
  {
    id: 9,
    body: (display,canvasOutput,code_pos) => {
display(canvasOutput(code_pos, { width: 300, height: 200 }));
},
    inputs: ["display","canvasOutput","code_pos"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-11`),
    expanded: [],
    variables: []
  },
  {
    id: 11,
    body: (view,codeEditor) => {
const code_size = view(codeEditor("canvas:img-size", {
  value: `drawPicture(ctx, "stern", 20, 20, 40, 40)
drawPicture(ctx, "stern", 80, 20, 80, 80)
drawPicture(ctx, "stern", 190, 20, 150, 150)`
}));
return {code_size};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_size"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-12`),
    expanded: [],
    variables: []
  },
  {
    id: 12,
    body: (display,canvasOutput,code_size) => {
display(canvasOutput(code_size, { width: 360, height: 190 }));
},
    inputs: ["display","canvasOutput","code_size"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-14`),
    expanded: [],
    variables: []
  },
  {
    id: 14,
    body: (view,codeEditor) => {
const code_loop = view(codeEditor("canvas:img-loop", {
  value: `// Wiese
ctx.fillStyle = "#a8e063"
ctx.fillRect(0, 150, 500, 50)

// eine Reihe Bäume in zufälliger ... nein: in wachsender Größe
for (let i = 0; i < 6; i++) {
  const größe = 40 + i * 12
  const x = 10 + i * 80
  // unten ausrichten, damit alle Bäume auf der Wiese stehen
  drawPicture(ctx, "baum", x, 170 - größe, größe, größe)
}`
}));
return {code_loop};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_loop"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-15`),
    expanded: [],
    variables: []
  },
  {
    id: 15,
    body: (display,canvasOutput,code_loop) => {
display(canvasOutput(code_loop, { width: 500, height: 200 }));
},
    inputs: ["display","canvasOutput","code_loop"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-17`),
    expanded: [],
    variables: []
  },
  {
    id: 17,
    body: (view,codeEditor) => {
const code_crop = view(codeEditor("canvas:img-crop", {
  value: `// ganzer Smiley links (Originalgröße 100x100)
drawPicture(ctx, "smiley", 10, 20, 100, 100)

// nur der obere linke Viertel-Ausschnitt, groß gezogen
drawPicture(ctx, "smiley",
  0, 0, 50, 50,        // Ausschnitt: obere linke Ecke des Bildes
  150, 20, 120, 120)   // Ziel: rechts, groß`
}));
return {code_crop};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_crop"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-18`),
    expanded: [],
    variables: []
  },
  {
    id: 18,
    body: (display,canvasOutput,code_crop) => {
display(canvasOutput(code_crop, { width: 300, height: 160 }));
},
    inputs: ["display","canvasOutput","code_crop"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-20`),
    expanded: [],
    variables: []
  },
  {
    id: 20,
    body: (view,codeEditor) => {
const code_ex1 = view(codeEditor("canvas:img-ex1", {
  value: `// Tipp: drawPicture(ctx, "baum", x, y, breite, höhe)
`
}));
return {code_ex1};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_ex1"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-21`),
    expanded: [],
    variables: []
  },
  {
    id: 21,
    body: (display,canvasOutput,code_ex1) => {
display(canvasOutput(code_ex1, { width: 460, height: 260 }));
},
    inputs: ["display","canvasOutput","code_ex1"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-22`),
    expanded: [],
    variables: []
  },
  {
    id: 22,
    body: (display,canvasTestReport,canvasTest,code_ex1) => {
display(canvasTestReport(canvasTest(code_ex1, {
  width: 460, height: 260,
  checks: [
    { name: "Mindestens 4 Bilder gezeichnet", run: ({ base }) => {
        const n = base.callsTo("drawImage").length;
        return { passed: n >= 4, detail: `${n} Bilder` };
    } },
    { name: "Bäume sind zu sehen (grün)", run: ({ base }) => {
        const r = base.region([46, 139, 87]);
        return { passed: r.count > 20, detail: `${r.count} grüne Punkte` };
    } },
    { name: "Ein Haus ist zu sehen", run: ({ base }) => {
        const r = base.region([244, 162, 89]);
        return { passed: r.count > 15, detail: `${r.count} Haus-Punkte` };
    } }
  ]
}), "Übung 1"));
},
    inputs: ["display","canvasTestReport","canvasTest","code_ex1"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-24`),
    expanded: [],
    variables: []
  },
  {
    id: 24,
    body: (view,codeEditor) => {
const code_ex2 = view(codeEditor("canvas:img-ex2", {
  value: `// drei Sterne in wachsender Größe nebeneinander
`
}));
return {code_ex2};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_ex2"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-25`),
    expanded: [],
    variables: []
  },
  {
    id: 25,
    body: (display,canvasOutput,code_ex2) => {
display(canvasOutput(code_ex2, { width: 320, height: 140 }));
},
    inputs: ["display","canvasOutput","code_ex2"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-26`),
    expanded: [],
    variables: []
  },
  {
    id: 26,
    body: (display,canvasTestReport,canvasTest,code_ex2) => {
display(canvasTestReport(canvasTest(code_ex2, {
  width: 320, height: 140,
  checks: [
    { name: "Drei Bilder mit Größenangabe", run: ({ base }) => {
        const dws = base.callsTo("drawImage").map(c => c.args[3]).filter(v => typeof v === "number");
        return { passed: dws.length >= 3, detail: `${dws.length} Bilder mit Breite/Höhe` };
    } },
    { name: "Die Sterne sind verschieden groß", run: ({ base }) => {
        const dws = base.callsTo("drawImage").map(c => c.args[3]).filter(v => typeof v === "number");
        if (dws.length < 3) return { passed: false, detail: "zu wenige Sterne mit Größe" };
        const span = Math.max(...dws) - Math.min(...dws);
        return { passed: span >= 40, detail: `Größenunterschied ${Math.round(span)} px` };
    } },
    { name: "Sterne sind zu sehen (gelb)", run: ({ base }) => {
        const r = base.region([255, 193, 7]);
        return { passed: r.count > 20, detail: `${r.count} gelbe Punkte` };
    } }
  ]
}), "Übung 2"));
},
    inputs: ["display","canvasTestReport","canvasTest","code_ex2"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
